'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const CheckMarkCircleOutlined = props => /*#__PURE__*/React__default["default"].createElement("svg", _extends__default["default"]({
  width: "79",
  height: "79",
  viewBox: "0 0 79 79",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React__default["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.5 39.3013C0.5 17.6396 18.0044 0 39.5 0C60.9956 0 78.5 17.6396 78.5 39.3013C78.5 60.963 60.9956 78.6026 39.5 78.6026C18.0044 78.6026 0.5 60.963 0.5 39.3013ZM5.375 39.3012C5.375 58.2667 20.6799 73.6899 39.5 73.6899C58.3201 73.6899 73.625 58.2667 73.625 39.3012C73.625 20.3357 58.3201 4.91259 39.5 4.91259C20.6799 4.91259 5.375 20.3357 5.375 39.3012ZM32.674 49.6179L22.4365 39.3013L19.024 42.7402L32.674 56.4956L61.924 27.0197L58.5116 23.5808L32.674 49.6179Z"
}), /*#__PURE__*/React__default["default"].createElement("mask", {
  id: "mask0_825_118290",
  style: {
    maskType: 'luminance'
  },
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "79",
  height: "79"
}, /*#__PURE__*/React__default["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.5 39.3013C0.5 17.6396 18.0044 0 39.5 0C60.9956 0 78.5 17.6396 78.5 39.3013C78.5 60.963 60.9956 78.6026 39.5 78.6026C18.0044 78.6026 0.5 60.963 0.5 39.3013ZM5.375 39.3012C5.375 58.2667 20.6799 73.6899 39.5 73.6899C58.3201 73.6899 73.625 58.2667 73.625 39.3012C73.625 20.3357 58.3201 4.91259 39.5 4.91259C20.6799 4.91259 5.375 20.3357 5.375 39.3012ZM32.674 49.6179L22.4365 39.3013L19.024 42.7402L32.674 56.4956L61.924 27.0197L58.5116 23.5808L32.674 49.6179Z"
})), /*#__PURE__*/React__default["default"].createElement("g", {
  mask: "url(#mask0_825_118290)"
}, /*#__PURE__*/React__default["default"].createElement("rect", {
  x: "0.5",
  width: "78",
  height: "78.6026"
})));

exports["default"] = CheckMarkCircleOutlined;
